module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.hasHeader) ? _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.title) ? _c('h3', {
    staticClass: "panel-title"
  }, [(_vm.icon) ? _c('fa', {
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.collapseClasses,
    style: (_vm.collapseStyle)
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("table"), _vm._v(" "), _vm._t("list"), _vm._v(" "), (_vm.hasFooter) ? _c('div', {
    staticClass: "panel-footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45788ca3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordions/accordion-pane.vue
// module id = 688
// module chunks = 85